<template>
  <div class="main">
    <div class="find"  @click="select">
      <p class="p1">当前求租人数<span>{{ count }}</span></p>
      <p class="p2">筛选符合我的求租用户</p>
      <div class="btn">
        立即筛选
        <img src="@/imgs/v2/next.png"/>
      </div>
      <img class="shop" src="@/imgs/v2/shops.png"/>
    </div>
    <ul class="link_item">
      <!--<li @click="-->
          <!--show = true-->
          <!--showType = 1-->
        <!--">-->
        <!--<img class="item_icon" src="@/imgs/v2/refunds_my.png"/>-->
        <!--<p class="p1">申请退款</p>-->
      <!--</li>-->
      <li @click="goToLink('/published')">
        <img class="item_icon" src="@/imgs/v2/release.png"/>
        <p class="p1">我的发布</p>
      </li>
      <li @click="$router.push('/server')">
        <img class="item_icon" src="@/imgs/v2/services.png"/>
        <p class="p1">联系客服</p>
      </li>
      <li @click="$router.push('/suggest')">
        <img class="item_icon" src="@/imgs/v2/complaints.png"/>
        <p class="p1">监督投诉</p>
      </li>
      <!--<li @click="$router.push('/about')">-->
        <!--<img class="item_icon" src="@/imgs/v2/about.png"/>-->
        <!--<p class="p1">关于我们</p>-->
      <!--</li>-->
    </ul>
    <van-dialog
      v-model="show"
      :close-on-click-overlay="showType !== 4"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div v-if="showType === 1" class="dialog">

        <h1>提示</h1>
        <p>
          您好，请联系在线客服申请核实
          <!--您未支付费用或时间还未达到退款时间<br>-->
          <!--请去发布信息支付费用<br>-->
          <!--30天未转出租出再来申请退款-->
        </p>
        <div class="know" @click="show = false">我知道了</div>
      </div>
      <div v-if="showType === 2" class="dialog2">
        <img :src="codeImg">
      </div>
      <div v-if="showType === 3" class="dialog3">
        <h1>筛选</h1>
        <van-field
          v-model="cityName"
          label="城市"
          readonly
          class="cell"
          label-class="la-title"
          input-align="right"
          right-icon="arrow"
          placeholder="请选择城市"
          @click="$router.push({ path: '/position', query: { type: 1 } })"
        />
        <van-field
          v-model="tradeName"
          label="行业"
          readonly
          label-class="la-title"
          class="cell"
          input-align="right"
          right-icon="arrow"
          placeholder="请选择行业"
          @click="getTradeList"
        />
        <div class="btns">
          <div class="btn" @click="show = false">取消</div>
          <div class="btn" @click="goToRent">确定</div>
        </div>
      </div>
      <div v-if="showType === 4" class="dialog dialog4">
        <h1>提示</h1>
        <p>
          发布后可访问
        </p>
        <van-field
          v-model="phone"
          label="手机号"
          class="cell"
          oninput="if (value.length > 11) value = value.slice(0, 11)"
          label-class="la-title"
          input-align="right"
          type="tel"
          placeholder="请输入手机号"
          @blur="onBlur"
        />
        <van-field
          v-model="code"
          label="验证码"
          type="number"
          oninput="if (value.length >6) value = value.slice(0, 6)"
          label-class="la-title"
          class="cell"
          input-align="right"
          placeholder="验证码"
          @click="onBlur"
        >
          <template #button>
            <van-button
              size="small"
              :disabled="time !== 0"
              color="#fd6a42"
              @click="sendMsg"
            >{{
              time !== 0 ? `${time}s后重新发送` : '发送验证码'
            }}</van-button>
          </template>
        </van-field>
        <div class="btns">
          <div class="btn" @click="$router.push('/publish')">去发布</div>
          <div class="btn" @click="getLogin">登录</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { headers, RandomNumBoth, citys } from '@/utils/util'
import { getLocation } from '@/utils/location'
import { getTradeList, getUserInfo, sendCode, login } from '@/api/api'
import { loginUrl } from '@/utils/config'
let timer = null
export default {
  name: 'Me',
  components: {
    vanDialog: Dialog.Component
  },
  data() {
    return {
      time: 0,
      count: 0,
      phone: '',
      code: '',
      codeImg: require('@/imgs/code.jpg'),
      userInfo: {},
      showType: 2,
      show: false,
      tradeList: [],
      tradeName: '',
      tradeId: '',
      topToastText: this.$store.getters.config.topToastText,
      cityName: this.$store.getters.cityName,
      token: ''
    }
  },
  created() {
    const token = this.$store.getters.token
    const { code = '' } = this.$route.query
      console.log(token)
    if (!token) {
      if (!code) {
        location.href = loginUrl(encodeURIComponent(location.href))
      } else {
        this.$store.dispatch('getLogin', code).then(token => {
          this.token = token
          this.init()
        })
      }
    } else {
      this.token = this.$getCookie('asses_token')
      this.init()
    }
  },
  methods: {
    init() {
      this.getUserInfo()
      this.getConfig()
      this.getLocation()
    },
    async getLocation() {
      const that = this
      let count = 0
      let timer = null
      let time = 1
      let speed = 23
      let res
      let city
      if (!this.$store.getters.cityName) {
        res = await getLocation()
        if (!res.data.city) return
        city = res.data.city
        await this.$store.dispatch('setCity', city)
      } else {
        city = this.$store.getters.cityName
      }

      this.cityName = city

      if (citys.includes(city.slice(0, 2))) {
        count = RandomNumBoth(5000, 6000)
      } else {
        count = RandomNumBoth(1000, 2000)
      }
      timer = setInterval(function() {
        that.count += speed
        if (count - that.count < 5 * speed) {
          speed = 1
          time = 100
        }

        if (that.count === count) {
          clearInterval(timer)
        }
      }, time)
    },
    select() {
      this.show = true
      this.showType = 3
    },
    showLogin() {
      if (!this.token) {
        this.showType = 4
        this.show = true
      }
    },
    linkShowLogin() {
      this.showType = 4
      this.show = true
    },
    goToLink(link) {
      if (!this.token) {
        this.linkShowLogin()
        return
      }
      this.$router.push(link)
    },
    async getConfig() {
      const data = await this.$store.dispatch('setConfig')
      this.topToastText = data.topToastText
    },
    async sendMsg() {
      const that = this
      if (!this.phone) {
        this.$notify('请先输入手机号')
        return
      }
      await sendCode({ phone: this.phone })
      this.time = 60
      timer = setInterval(() => {
        that.time = that.time - 1
        if (that.time <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    async getLogin() {
      const res = await login({
        phone: this.phone,
        code: this.code
      })
      await this.$store.dispatch('setToken', res.data.token)
      this.token = this.$getCookie('asses_token')
      this.userInfo = res.data.userInfo
      this.show = false
    },
    async getUserInfo() {
        console.log(this.$store.getters.userInfo)
        if(this.$store.getters.userInfo && this.$store.getters.userInfo.avatarUrl){
            this.userInfo = this.$store.getters.userInfo
        }else{
            const res = await getUserInfo(headers())
            console.log(res)
            this.userInfo = res.data
            await this.$store.dispatch('setUserInfo', res.data)
        }

    },
    onBlur() {
      window.scrollTo(0, 0)
    },
    saveImg() {
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = '快转二维码' // 设置图片名称没有设置则为默认
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = this.codeImg
      this.show = false
    },
    goToRent() {
      this.$router.push('/rent')
    },
    async getTradeList() {
      const res = await getTradeList()
      this.tradeList = res.data.tradeList
      this.showDistrict = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    overflow: hidden;
    .find {
      width: 690px;
      margin: 30px auto 0;
      border-radius: 8px;
      position: relative;
      height: 230px;
      padding-left: 46px;
      overflow: hidden;
      background-color: #fff;
      box-shadow: 0 8px 12px #ebedf0;
      .p1{
        font-size: 24px;
        margin-top: 22px;
        line-height: 32px;
        span{
          color: #fe6b43;
          margin-left: 30px;
          font-weight: bold;
        }
      }
      .p2{
        font-size: 36px;
        margin-top: 18px;
        color: #fe6b43;
        line-height: 48px;
      }
      .btn{
        width: 240px;
        height: 60px;
        background-color: #ff5b3b;
        color: #fff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 34px;
        margin-top: 16px;
        img{
          width: 32px;
          height: 32px;
          display: block;
          margin-left: 15px;
        }
      }
      .shop{
        display: block;
        position: absolute;
        width: 181px;
        height: 181px;
        right: 50px;
        top: 34px;
      }
    }
    .link_item{
      display: flex;
      width: 690px;
      height: 360px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 8px 12px #ebedf0;
      margin: 30px auto 0;
      padding: 30px 18px;
      flex-wrap: wrap;
      li{
        width: 216px;
        height: 150px;
        .item_icon{
          display: block;
          width: 60px;
          height: 60px;
          margin: 26px auto 0;
        }
        .p1{
          font-size: 24px;
          text-align: center;
          line-height: 32px;
          margin-top: 10px;
        }
      }
    }
    .dialog {
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      padding: 0 0.84rem 0.52rem 0.84rem;
      position: relative;

      h1 {
        font-size: 36px;
        line-height: 120px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
      p {
        font-size: 28px;
        white-space: nowrap;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
      }
      .know {
        margin: 0.82667rem auto 0 auto;
        width: 4rem;
        height: 1.06667rem;
        text-align: center;
        line-height: 1.06667rem;
        background: #fd6a42;
        border-radius: 0.10667rem;
        font-size: 0.42667rem;
        font-family: PingFang SC;
        font-weight: 800;
        color: #fefefe;
      }
      .btns {
        width: 100%;
        display: flex;
        margin-top: 28px;
        justify-content: space-between;
        .btn {
          width: 240px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          background: #fd6a42;
          border-radius: 8px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #fefefe;
          justify-content: center;
        }
      }
    }
    .dialog2 {
      padding: 30px;
      width: 100%;
      img {
        width: 100%;
      }
      div {
        margin: 62px auto 0 auto;
        width: 300px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        background: rgba(253, 106, 66, 1);
        border-radius: 8px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(254, 254, 254, 1);
      }
    }
    .dialog3 {
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      padding: 0 30px 108px 30px;
      h1 {
        margin-bottom: 26px;
        font-size: 36px;
        line-height: 100px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
      .btns {
        width: 100%;
        display: flex;
        margin-top: 28px;
        justify-content: space-between;
        .btn {
          width: 240px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          background: rgba(240, 241, 242, 1);
          border-radius: 8px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(153, 153, 153, 1);
          justify-content: center;
          &:nth-child(2) {
            background: #fd6a42;
            color: #fefefe;
          }
        }
      }
      .cell {
        margin-bottom: 50px;
        width: 100%;
        height: 80px;
        background: rgba(240, 241, 242, 1);
        border-radius: 8px;
      }
      .la-title {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
      }
    }
    .dialog4 {
      padding: 0 30px 30px;
    }
  }
</style>